import { CloseIcon } from '@chakra-ui/icons';
import {
  Flex,
  FormControl,
  FormErrorMessage,
  IconButton,
  Select,
  Text,
} from '@chakra-ui/react';
import { useState } from 'react';

import { truefileServerApi } from 'api/truefilesServerApi';
import { IFileTypeModel } from 'api/types/trueFileServerTypes';

interface FileRowProps {
  fileName: string;
  fileType: string;
  showError: boolean;
  onRemove: (name: string)=> void;
  onTypeChange: (name: string, type: string)=> void;
}

const fetchFileTypes = async (): Promise<IFileTypeModel[]> => {
  const response = await truefileServerApi.GET('/api/files/types');
  return response.data!;
};

export function FileRow({
  fileName,
  fileType,
  showError,
  onRemove,
  onTypeChange,
}: FileRowProps): JSX.Element {
  const [docTypes, setDocTypes] = useState<IFileTypeModel[]>([]);
  const [loading, setLoading] = useState(true);

  if (docTypes.length === 0 && loading) {
    fetchFileTypes()
      .then(setDocTypes)
      .catch(() => setLoading(false))
      .finally(() => setLoading(false));
  }

  return (
    <Flex
      align='center'
      gap='1rem'
      mb='0.5rem'
      border='1px solid'
      borderColor='gray.200'
      borderRadius='8px'
      p='0.5rem 1rem'
    >
      <IconButton
        aria-label='Remove file'
        icon={<CloseIcon boxSize={3} />}
        size='xs'
        variant='ghost'
        onClick={() => onRemove(fileName)}
      />

      <Text flex='1' isTruncated>
        {fileName}
      </Text>

      <FormControl isInvalid={showError && !fileType} w='auto'>
        <Select
          value={fileType}
          onChange={(e) => onTypeChange(fileName, e.target.value)}
          border='1px solid'
          borderColor='gray.500'
          borderRadius='8px'
          focusBorderColor='red.400'
          isDisabled={loading}
        >
          <option value=''>Select type</option>

          {docTypes.map((dt) => (
            <option key={dt.id} value={dt.id}>
              {dt.name}
            </option>
          ))}
        </Select>

        <FormErrorMessage>Select file type</FormErrorMessage>
      </FormControl>
    </Flex>
  );
}
